import geolocalization from './es/geolocalization.json';
let items = {
    ...geolocalization
}

export default items;